Ext.define('WindowKellerIdentkods', {
    extend: 'Ext.ux.window.WindowExd',
    title: Lang.identyfikator_elektroniczny.capitalise(),
    width: 630,
    height: 250,
    closable: false,
    collapsible: false,
    modal: true,
    resizable: false,
    scrollable: true,
    layout: 'fit',
    initComponent: function () {
        this.cid = Ext.id();
        this.items = [{
            xtype: 'panel',
            layout: 'column',
            scrollable: WindowExdMobileDEVICEV,
            items: [{
                columnWidth: 1,
                xtype: 'form',
                id: this.cid + 'formpanel',
                bodyStyle: 'padding:10px 10px 10px 10px',
                defaults: {
                    anchor: '0',
                    labelWidth: 150,
                    labelAlign: WindowExdMobileDEVICEV ? 'top' : 'left'
                },
                items: [{
                    id: this.cid + "numer",
                    name: "numer",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.numer,
                    allowBlank: false,
                    maxLength: 12,
                    minLength: 12,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "eiid",
                    name: "eiid",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.eiid,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste
                }, {
                    id: this.cid + "nazwa",
                    name: "nazwa",
                    xtype: 'textfieldexd',
                    fieldLabel: Lang.nazwa_karty,
                    allowBlank: false,
                    blankText: Lang.pole_nie_moze_byc_puste
                }]
            }]
        }];
        this.buttons = [{
            xtype: 'tbfill'
        }, {
            id: this.cid + 'save',
            text: Lang.zapisz,
            scope: this,
            handler: this.saveOp
        }, {
            id: this.cid + 'cancel',
            text: Lang.anuluj,
            scope: this,
            handler: this.closeOp
        }];
        this.callParent(arguments);
    },
    showW: function (obiektid) {
        if (!validPrivilegesOperatorComplex(ViewKellerIdentkods.accessPropertyManageName)) {
            Ext.MessageBox.alert(Lang.error, Lang.brak_uprawnien_do_wykonania_operacji);
            return;
        }
        this.obiekt = null;
        this.show();
        this.center();
    },
    saveOp: function () {
        var canWrite = false;
        var numer = Ext.getCmp(this.cid + "numer").getValue();
        if (numer.length !== 12) {
            Ext.MessageBox.alert(Lang.error, Lang.numer_identyfikatora_musi_miec_12_znakow);
            return;
        }
        if (Ext.getCmp(this.cid + "numer").isValid() && Ext.getCmp(this.cid + "eiid").isValid() && Ext.getCmp(this.cid + "nazwa").isValid()) {
            canWrite = true;
        }
        if (canWrite) {
            sendAjaxDataJsonRpcL("rest/kellerindentkods/saveObject", {
                numer: Ext.getCmp(this.cid + "numer").getValue(),
                eiid: Ext.getCmp(this.cid + "eiid").getValue(),
                nazwa: Ext.getCmp(this.cid + "nazwa").getValue2(),
            }, this, function (data) {
                if (data.status) {
                    data = data.data;
                    this.obiektid = data.id;
                    this.close();
                } else {
                    Ext.MessageBox.alert(Lang.error, data.error);
                }
                if (this.callbackF)
                    this.callbackF();
            });
        } else {
            Ext.MessageBox.alert(Lang.error, Lang.dane_niepoprawne);
        }
    },
    closeOp: function () {
        this.close();
    }
});
